.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 16px;
  border-radius: 14px;
  background: linear-gradient(
    145deg,
    rgba(124, 58, 237, 0.22),
    rgba(8, 6, 14, 0.9)
  );
  border: 1px solid var(--color-border-strong);
  color: var(--color-gold-bright);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 8px 24px rgba(0, 0, 0, 0.25);
}

.icon {
  width: 28px;
  height: 28px;
  opacity: 0.95;
  filter: drop-shadow(0 2px 6px rgba(124, 58, 237, 0.35));
}
